import axios from 'axios';

const ep_list_retry = `${process.env.VUE_APP_PB_API}/ags/retry-bsims/list`;
const ep_retry_bsims = `${process.env.VUE_APP_PB_API}/ags/retry-bsims/retry`;
const ep_retry_bsims_all = `${process.env.VUE_APP_PB_API}/ags/retry-bsims/retry-all`;

const listRetry = (data) => {
    console.log('listRetryData:', `${ep_list_retry}?page=${data.current_page}`);
    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${ep_list_retry}?page=${data.current_page}`,
        headers: {
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    }

    return axios.request(config)
        .then((response) => JSON.stringify(response.data))
        .catch((error) => JSON.stringify(error));
}

const retryBSIMS = (data) => {
    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: ep_retry_bsims,
        headers: {
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    }

    return axios.request(config)
        .then((response) => JSON.stringify(response.data))
        .catch((error) => JSON.stringify(error));
}

const retryBSIMSall = (data) => {
    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: ep_retry_bsims_all,
        headers: {
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    }

    return axios.request(config)
        .then((response) => JSON.stringify(response.data))
        .catch((error) => JSON.stringify(error));
}

export {
    listRetry, retryBSIMS, retryBSIMSall
}